var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex_item piece_stand",class:[_vm.location_key, _vm.$parent.env]},[_c('ul',[_c('li',[_vm._v(_vm._s(_vm._f("location_name")(_vm.location_key)))]),_vm._v(" "),_vm._l((Array.from(_vm.$parent.mediator.hold_pieces.get(_vm.location_key))),function(ref){
var piece_key = ref[0];
var count = ref[1];
return [(count >= 1)?[_c('li',[_c('span',{staticClass:"piece_name"},[_vm._v(_vm._s(_vm._f("piece_name")(piece_key)))]),_vm._v(" "),(count >= 2)?[_c('span',{staticClass:"piece_count"},[_vm._v(_vm._s(count))])]:_vm._e()],2)]:_vm._e()]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c714a1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/piece_stand.vue
// module id = 4xnO
// module chunks = 1